
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';



const reducer = (state, action) => {
    if (action.type === "REPLACE_CONSULTS") {
        return {
            ...state,
            consults: action.consults,
            auxconsults: action.consults
        }
    } else if (action.type === "SHOW_MODAL") {
        return {
            ...state,
            visiblerespuesta: action.visiblerespuesta
        }
    } else if (action.type === "HANDLE_OK_MODAL") {
        return {
            ...state,
            visiblerespuesta: action.visiblerespuesta
        }
    } else if (action.type === "HANDLE_CANCEL_MODAL") {
        return {
            ...state,
            visiblerespuesta: action.visiblerespuesta
        }
    } else if (action.type === "CHANGE_STATE_LOGIN") {
        return {
            ...state,
            user: action.user
        }
    } else if (action.type === "SET_STATE_SOCIO") {
        return {
            ...state,
            user: {
                ...state.user,
                idSocio: action.idSocio,
            }
        }
    }
    else if (action.type === "SET_NOMBRE_SOCIO") {
        return {
            ...state,
            nombreSocio: action.nombreSocio,
        }
    }
    else if (action.type === "SET_STATE_USER") {
        return {
            ...state,
            user: action.user
        }
    }
    else if (action.type === "REPLACE_CAR") {
        return {
            ...state,
            cocheDGT: action.datosDGT
        }
    } else if (action.type === "STATE_MATRICULA") {
        return {
            ...state,
            matriculaCoche: action.validateMatricula === undefined ? {} : action.validateMatricula
        }
    } else if (action.type === "UPDATE_VRID") {
        return {
            ...state,
            sesionhaynes: action.sesionhaynes
        }
    } else if (action.type === "UPDATE_BRANDS") {
        return {
            ...state,
            brands: action.brands
        }
    } else if (action.type === "UPDATE_MODELS") {
        return {
            ...state, models: {},
            models: action.models
        }
    } else if (action.type === "UPDATE_TYPE") {
        return {
            ...state, typeEngine: {},
            typeEngine: action.typeEngine,
        }
    } else if (action.type === "UPDATE_SYSTEM") {
        return {
            ...state, system: {},
            system: action.system,
        }
    }
    else if (action.type === "UPDATE_SELECT_MARCA") {
        return {
            ...state,
            selectmarca: action.selectmarca,
            cocheDGT: action.datosDGT
        }
    } else if (action.type === "UPDATE_SELECT_MODELO") {
        return {
            ...state,
            selectmodelo: action.selectmodelo,
            cocheDGT: action.datosDGT
        }
    } else if (action.type === "UPDATE_SELECT_TYPE") {
        return {
            ...state,
            selecttipo: action.selecttipo,
            cocheDGT: action.datosDGT
        }
    }
    else if (action.type === "UPDATE_SELECT_SYSTEM") {
        return {
            ...state,
            selectsystem: action.selectsystem,
        }
    }
    else if (action.type === "UPDATE_SELECT_ESTADO") {

        return {
            ...state,
            selectestado: action.selectestado,
            consults: action.consults
        }
    }
    else if (action.type === "SET_FILES") {
        return {
            ...state,
            fileincidence: action.fileincidence,
        }
    }
    else if (action.type === "FICHERO_INCIDENCIA") {
        return {
            ...state,
            ficherostecnico: action.ficherostecnico,
        }
    }
    else if (action.type === "STATE_TYPE_CONSULT") {
        return {
            ...state,
            esMatricula: action.esMatricula,
        }
    }
    else if (action.type === "STATE_REPREGUNTAR") {
        return {
            ...state,
            esRepreguntar: action.esRepreguntar,
        }
    }
    else if (action.type === "STATE_REPREGUNTAR_CONSULT") {
        return {
            ...state,
            consulta: action.consulta,
        }
    }
    else if (action.type === "STATE_DATA_MATRICULA_FR") {

        return {
            ...state,
            datosMatricula: action.datosMatricula,
        }
    }
    else if (action.type === "STATE_ALL_USER") {

        return {
            ...state,
            allDataUser: action.allDataUser,
        }
    }
    else if (action.type === "STATE_URL_WEB") {
        return {
            ...state,
            urlweb: action.urlweb,
        }
    }
    else if (action.type === "STATE_CHECK_CONDICIONES") {
        return {
            ...state,
            aceptoCondiciones: action.aceptoCondiciones,
        }
    }
    else if (action.type === "STATE_ALL_COURSE") {
        return {
            ...state,
            allCourse: action.allCourse,
        }
    }
    else if (action.type === "STATE_CHECK_INVITACION") {
        return {
            ...state,
            aceptoInvitacion: action.aceptoInvitacion,
        }
    }
    else if (action.type === "STATE_IDCURSO") {
        return {
            ...state,
            idCurso: action.idCurso,
        }
    }
    else if (action.type === "STATE_ALL_COURSE_ACTIVO") {
        return {
            ...state,
            cursoActivo: action.cursoActivo,
        }
    }
    else if (action.type === "STATE_IDCURSO_CERRAR_REGISTRO") {
        return {
            ...state,
            idcursoCerrar: action.idcursoCerrar,
        }
    }
    else if (action.type === "STATE_ACTIVO_FILTRO_CURSO") {
        return {
            ...state,
            activofiltroCurso: action.activofiltroCurso,
        }
    }

    else if (action.type === "STATE_ACTIVO_DESCARGA") {
        return {
            ...state,
            activeButtonDescargar: action.activeButtonDescargar,
        }
    }
    else if (action.type === "STATE_ACTIVO_CERRAR_CURSO") {
        return {
            ...state,
            activebuttonEliminar: action.activebuttonEliminar,
        }
    }


    return state;
};


const logger = store => next => action => {
    console.log('dispatching', action)
    let result = next(action)
    console.log('next state', store.getState());
    return result;
}



export default createStore(reducer, {
    user: { nombre: "", apellido1: "", apellido2: "", email: "", telefono: "", cif: "", idSocio: "" },
    allDataUser: [], urlweb: "", aceptoCondiciones: true, allCourse: {}, aceptoInvitacion: false, idCurso: "", cursoActivo: {},
    idcursoCerrar: "", activofiltroCurso: true, activeButtonDescargar: true, activebuttonEliminar: true, nombreSocio: ""

}, applyMiddleware(logger, thunk));